import React, { useState } from 'react';
import './authors.m.css';
import RightSideBar from '../../molecules/right-side-bar';
import get from 'lodash/get';
import { object } from 'prop-types';
import Button from '../../atoms/button';
import { DownArrow } from '../../atoms/icons/down-arrow';
import ListHeaderTitle from '../../atoms/list-header-title';
import AccountIcon from '../../atoms/icons/account';

export const AuthorsPage = props => {
  const [offset, setOffset] = useState(20);
  const allAuthors = props?.data?.author?.filter(author => {
    return (
      get(author, ['metadata', 'Public Author']) &&
      get(author, ['avatar-url']) !== null &&
      author.bio !== null
    );
  });
  const authors = allAuthors.slice(0, offset);
  const totalAuthors = allAuthors.length;

  const Author = author => {
    const heading = author?.name ?? '';
    const avatar = get(author, ['avatar-url']) ?? heading.slice(0, 1);
    const socials = author?.social ?? {};
    const bio = author?.bio ?? '';
    const socialNames = Object.keys(socials);
    const name = heading?.split(' ');
    const [firstname, ...lastname] = name ?? [];
    let socialUrl;
    const validSocials = ['twitter', 'instagram', 'facebook', 'linkedin'];

    return (
      <div styleName="author-heading">
        {avatar.length < 2 ? (
          <div styleName="author-name">{heading.slice(0, 1)}</div>
        ) : (
          <img className="author-image" src={avatar} />
        )}
        <div styleName="author-details">
          <div styleName="author-title-social">
            <span styleName="author-name_first">
              <a href={`/author/${author.id}/${author.slug}`} target="_blank" rel="noreferrer">
                {firstname}
                <span styleName="author-name_last">{` ${lastname.join(' ')}`}</span>
              </a>
            </span>
          </div>
          <div styleName="author-bio">
            <p>{bio}</p>
          </div>
          <div styleName="social">
            {socials &&
              Object.values(socials).map((social, i) => {
                socialUrl =
                social?.url && social?.handle ? `https://www.${socialNames[i]}.com/${social?.handle}` : social?.url ? `https://www.${socialNames[i]}.com/${social?.url}` : '#';
                return (
                  <a key={i} href={socialUrl} target="_blank" rel="noreferrer">
                    <span
                      styleName={
                        validSocials.includes(socialNames[i])
                          ? `${socialNames[i]}-icon icon`
                          : 'icon'
                      }
                      className={`icon-ic_${socialNames[i]}`}
                    ></span>
                  </a>
                );
              })}
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="container">
      <div styleName="author-story-list" className="row-section sidebar">
        <div>
          <div styleName="profile_badge">
            <ListHeaderTitle title="ALL AUTHORS">
              <AccountIcon color="sixth-color" />
            </ListHeaderTitle>
          </div>
          {authors &&
            authors.map(author => {
              return Author(author);
            })}
          {authors.length !== totalAuthors && (
            <Button
              label="More Authors"
              rounded="full"
              variant="outline"
              styleName="view-all-large"
              icon="right"
              onClick={() => setOffset(offset => offset + 20)}
            >
              <DownArrow />
            </Button>
          )}
        </div>
        <RightSideBar />
      </div>
    </div>
  );
};

AuthorsPage.propTypes = {
  data: object
};
